import Lightbulb from '../src/Lightbulb';
export default Lightbulb;
